// emailSubscriptions/actionTypes.js

const CHANGE_SUBSCRIPTION_FILTER = '@@emailSubscriptions/CHANGE_SUBSCRIPTION_FILTER';
const CHANGE_CATEGORY_SELECTION = '@@emailSubscriptions/CHANGE_CATEGORY_SELECTION';
const CHANGE_TEAM_SELECTION = '@@emailSubscriptions/CHANGE_TEAM_SELECTION';
const CHANGE_DIVISION_SELECTION = '@@emailSubscriptions/CHANGE_DIVISION_SELECTION';

const REQUEST_CATEGORIES = '@@emailSubscriptions/REQUEST_CATEGORIES';
const CATEGORIES_RESPONSE = '@@emailSubscriptions/CATEGORIES_RESPONSE';

const REQUEST_SAVE = '@@emailSubscriptions/REQUEST_SAVE';
const SAVE_RESPONSE = '@@emailSubscriptions/SAVE_RESPONSE';

const HYDRATE_SUBSCRIPTIONS = '@@emailSubscriptions/HYDRATE_SUBSCRIPTIONS';

export default {
    CHANGE_SUBSCRIPTION_FILTER,
    CHANGE_CATEGORY_SELECTION,
    CHANGE_TEAM_SELECTION,
    CHANGE_DIVISION_SELECTION,
    REQUEST_CATEGORIES,
    CATEGORIES_RESPONSE,
    REQUEST_SAVE,
    SAVE_RESPONSE,
    HYDRATE_SUBSCRIPTIONS
};